var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _vm.widget.widgetList.length <= 0
        ? _c("smart-widget-grid", {
            attrs: {
              layout: _vm.gridLayout,
              "row-height": 48,
              margin: [15, 15],
              "is-static": false,
              "auto-size": true,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: _vm.defaultSlotName,
                  fn: function () {
                    return [
                      _c(
                        "smart-widget",
                        {
                          attrs: {
                            title: "操作提示",
                            refresh: "",
                            fullscreen: "",
                          },
                        },
                        [
                          _c("div", { staticClass: "layout-center" }, [
                            _c("h3", [
                              _vm._v("选择左侧图表组件，鼠标点击即可加入画布"),
                            ]),
                          ]),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.widget.widgetList.length > 0
        ? _c("smart-widget-grid", {
            attrs: {
              layout: _vm.gridLayout,
              "row-height": 48,
              margin: [15, 15],
              "is-static": false,
              "auto-size": true,
            },
            scopedSlots: _vm._u(
              [
                _vm._l(_vm.widget.widgetList, function (item, index) {
                  return {
                    key: item.id,
                    fn: function () {
                      return [
                        _c(
                          "smart-widget",
                          {
                            attrs: {
                              simple: !item.options.showHeader,
                              title: item.options.label,
                              refresh: item.options.showRefresh,
                              fullscreen: item.options.showFullscreen,
                              isActived:
                                _vm.designer.selectedWidget &&
                                _vm.designer.selectedWidget.id == item.id,
                            },
                            on: {
                              "on-refresh": function ($event) {
                                return _vm.onRefresh(item)
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "container-com" },
                              [
                                "container" === item.category
                                  ? [
                                      _c(item.type + "-widget", {
                                        key: item.id,
                                        tag: "component",
                                        attrs: {
                                          widget: item,
                                          designer: _vm.designer,
                                          "parent-list": _vm.widget.widgetList,
                                          "index-of-parent-list": index,
                                          "parent-widget": _vm.widget,
                                        },
                                      }),
                                    ]
                                  : [
                                      _c(item.type + "-widget", {
                                        key: item.id,
                                        tag: "component",
                                        attrs: {
                                          layout: _vm.gridLayout,
                                          field: item,
                                          designer: _vm.designer,
                                          "parent-list": _vm.widget.widgetList,
                                          "index-of-parent-list": index,
                                          "parent-widget": _vm.widget,
                                          "design-state": true,
                                        },
                                      }),
                                    ],
                                _vm._v(" "),
                                _vm.designer.selectedWidget &&
                                _vm.designer.selectedWidget.id == item.id
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "del-span",
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeSelectedChart(
                                              index,
                                              item.id
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("el-icon", {
                                          staticClass: "el-icon-delete",
                                          attrs: { size: "20" },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ]
                        ),
                      ]
                    },
                    proxy: true,
                  }
                }),
              ],
              null,
              true
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }